import React from "react";
import PropTypes from "prop-types";
import Select from "./select";
import Switch from "./switch";
import DateTime from "./date";

const FilterBox = ({
  id,
  label,
  selectedValue,
  values,
  filterRenderer,
  onChange,
  onClear,
  type
}) => {
  const onSelectChange = value => {
    onChange({
      key: id,
      value
    });
  };
  const onSwitchChange = value => {
    if (value === null) {
      onClear(id);
    } else {
      onChange({
        key: id,
        value
      });
    }
  };
  const onDateChange = value => {
    onChange({
      key: id,
      value,
      type: "date"
    });
  };

  if (type === "boolean") {
    return (
      <Switch
        id={id}
        labelTrue="Automaticas"
        labelFalse="Manual"
        value={selectedValue}
        onFilterChange={newValue => onSwitchChange(newValue)}
      />
    );
  }
  if (type === "date") {
    return (
      <DateTime
        id={id}
        label={label}
        startDate={selectedValue.startDate}
        endDate={selectedValue.endDate}
        onFilterChange={newValue => onDateChange(newValue)}
      />
    );
  }
  return (
    <Select
      id={id}
      selectedValue={selectedValue}
      values={values}
      label={label}
      onFilterChange={newValue => onSelectChange(newValue)}
      onClear={onClear}
      filterRenderer={filterRenderer}
    />
  );
};

FilterBox.propTypes = {
  selectedValue: PropTypes.oneOfType([PropTypes.string, PropTypes.bool, PropTypes.shape({})]),
  onChange: PropTypes.func,
  onClear: PropTypes.func,
  id: PropTypes.string,
  label: PropTypes.string,
  values: PropTypes.arrayOf(
    PropTypes.oneOfType([PropTypes.string, PropTypes.bool, PropTypes.number])
  ),
  type: PropTypes.oneOf(["date", "boolean", "string"]),
  filterRenderer: PropTypes.func
};
FilterBox.defaultProps = {
  onChange: () => {},
  onClear: () => {},
  values: [],
  id: "",
  label: "",
  selectedValue: "",
  type: "string",
  filterRenderer: value => value
};

export default FilterBox;
